import { SxProps } from "@mui/material";

export const sharedStyles: { [key: string]: SxProps } = {
  card: {
    p: 2,
    "&:not(last-of-type)": {
      borderBottom: "1px solid",
      borderBottomColor: "grey.200",
    },
    elevation: { sm: 0 },
    mb: { md: 1 },
  },
  cardHeader: {
    color: "primary.main",
    mt: 1,
    mb: 2,
    mx: 0,
  },
  wrapper: {
    mb: 2,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "end",
  },
  label: {
    pr: 2,
    width: { xs: "49%", sm: "30%" },
  },
  paymentLabel: {
    width: { xs: "51%", sm: "70%" },
  },
  value: {
    width: { xs: "51%", sm: "70%" },
  },
  valueAlignRight: {
    textAlign: "right",
    width: { xs: "51%", sm: "70%" },
  },
  paymentValue: {
    width: { xs: "49%", sm: "30%" },
  },
};
